<template>
    <div>
        <v-row>
            <v-col>
                <hr />
            </v-col>
        </v-row>

        <v-row >
            <v-col cols="4">
                <v-select
                    data-testid="social-media-icon-select"
                    class="social-media-icon-select"
                    :items="iconList"
                    item-text="name"
                    item-value="path"
                    label="Icon"
                    v-model="linkIcon"
                />
            </v-col>

            <v-col cols="4">
                <div class="v-text-field v-text-field--filled">
                    <div class="v-label v-label--active v-label theme--dark ">
                        Preview
                    </div>
                </div>
                <a
                  :href="uri"
                  target="_blank"
                  class="rounded social-icon-link"
                >
                    <img
                        alt=""
                        :src="icon"
                        :href="uri"
                        width="30"
                        height="30"
                        class="social-icon"
                    >
                </a>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <app-input
                    data-testid="social-media-url-input"
                    class="social-media-url-input mb-0 pb-0"
                    :type="'text'"
                    label="Uri"
                    v-model="linkUri"
                    :hint="'(url will open in a new tab)'"
                    :persistent-hint="true"
                />
            </v-col>
        </v-row>
        <v-row class="ma-0 pa-0">
            <v-col cols="1" class="ma-0 pb-6">
                <v-btn
                  data-testid="social-media-delete-btn"
                  class="social-media-delete-btn my-3"
                  block
                  small
                  color="error"
                  @click="removeLink"
                >
                  Delete
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import AppInput from "@/components/global/AppInput";

export default {
  props: {
    id: {
      type: Number
    },
    index: {
      type: Number
    },
    icon: {
      type: String
    },
    uri: {
      type: String
    },
    iconList: {
      type: Array
    }
  },

  computed: {
    linkIcon: {
      get() {
        return this.icon;
      },

      set(value) {
        this.$store.dispatch("updateIcon", { icon: value, index: this.index });
      }
    },
    linkUri: {
      get() {
        return this.uri;
      },

      set(value) {
        this.$store.dispatch("updateUri", { uri: value, index: this.index });
      }
    }
  },

  components: {
    AppInput
  },

  methods: {
    removeLink() {
      this.$store.dispatch("removeLink", this.index);
    }
  }
};
</script>

<style>
.social-icon-link {
    display: inline-block;
    width: 30px;
    height: 30px;
}

.social-icon {
    text-indent: 100%;
    white-space: nowrap;
    overflow: hidden;
}

.theme--dark .social-icon-link {
  background: hsla(0,0%,100%,.08);
}

.theme--light .social-icon-link {
  background: rgba(0,0,0,.12)
}
</style>
